import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import EditPlannerElementSet from "./routes";
export default store => ({
  path: "manage-data-sets",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "data-sets" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [EditPlannerElementSet(store)],
});
